@if (mode() === formMode.VIEW) {
  <!-- Vista de solo lectura (Modo Viewer) -->
  @if (thirdPartyData() || thirdPartyForm()?.value; as data) {
    <div class="row mb-3">
      <div class="col-md-3">
        <div class="form-group">
          <label>Nombre Conductor Tercero</label>
          <div class="form-group">
            <strong>{{ data.thirdPartyDriverName || 'No especificado' }}</strong>
          </div>
        </div>
      </div>      <div class="col-md-3">
        <div class="form-group">
          <label>RUT / Licencia Conductor </label>
          <div class="form-group">
            <strong>{{ data.thirdPartyLicense || 'No especificado' }}</strong>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>Clase Licencia Conductor</label>
          <div class="form-group">
            <strong>{{ data.thirdPartyLicenseClass || 'No especificada' }}</strong>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>Nombre Propietario Tercero</label>
          <div class="form-group">
            <strong>{{ data.thirdPartyOwnerName || 'No especificado' }}</strong>
          </div>
        </div>
      </div>

    </div>

    <div class="row mb-3">
      <div class="col-md-4">
        <div class="form-group">
          <label>Teléfono de Contacto</label>
          <div class="form-group">
            <strong>{{ data.thirdPartyPhone || 'No especificado' }}</strong>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Patente Vehículo Tercero</label>
          <div class="form-group">
            <strong>{{ data.plate || data.thirdPartyPlate || 'No especificado' }}</strong>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Año Vehículo Tercero</label>
          <div class="form-group">
            <strong>{{ data.year || data.thirdPartyYear || 'No registrado' }}</strong>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <div class="form-group">
          <label>Marca Tercero</label>
          <div class="form-group">
            <strong>{{ findBrandName(data.brandCode || data.thirdPartyBrandCode) }}</strong>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Modelo Tercero</label>
          <div class="form-group">
            <strong>{{ findModelName(data.modelCode || data.thirdPartyModelCode) }}</strong>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <div class="form-group">
          <label>¿Tiene seguro contra todo riesgo?</label>
          <div class="form-group">
            <strong>{{ (data.hasInsurance || data.thirdPartyHasInsurance) ? 'SÍ' : 'NO' }}</strong>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>¿Asumió responsabilidad en el lugar?</label>
          <div class="form-group">
            <strong>{{ (data.tookResponsibility || data.thirdPartyTookResponsibility) ? 'SÍ' : 'NO' }}</strong>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="alert alert-secondary mb-0">No se registró información del tercero involucrado.</div>
  }
} @else {
  <!-- Formulario Interactivo (Creación / Edición) -->
  @if (thirdPartyForm(); as form) {
    <div [formGroup]="form">
      <!-- Switch del Propietario -->
      <div class="row mb-3">
        <div class="col-md-12">
          <div class="form-check form-switch p-3 rounded border border-gray-subtle">
            <input class="form-check-input ms-0" type="checkbox" id="isOwnerSameAsDriver" 
                   [ngModel]="isOwnerSameAsDriver()" 
                   (ngModelChange)="toggleOwnerSameAsDriver($event)" 
                   [ngModelOptions]="{standalone: true}">
            <label class="form-check-label fw-semibold ms-3" for="isOwnerSameAsDriver">¿El propietario es el mismo conductor?</label>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3 mb-3">
          <label class="form-label fw-semibold">Nombre Conductor Tercero *</label>
          <input type="text" class="form-control" formControlName="thirdPartyDriverName">
        </div>
        <div class="col-md-3 mb-3">
          <label class="form-label fw-semibold">RUT / Licencia Conductor Tercero *</label>
           <input type="text" class="form-control" formControlName="thirdPartyLicense">
        </div>
        <div class="col-md-3 mb-3">
          <label class="form-label fw-semibold">Clase Licencia Conductor Tercero *</label>
          <input type="text" class="form-control" formControlName="thirdPartyLicenseClass" placeholder="Ej: Clase B">
        </div>
        <div class="col-md-3 mb-3">
          <label class="form-label fw-semibold">Nombre Propietario Tercero *</label>
          <input type="text" class="form-control" formControlName="thirdPartyOwnerName">
        </div>

      </div>
      <div class="row">
        <div class="col-md-4 mb-3">
          <label class="form-label fw-semibold">Teléfono de Contacto *</label>
          <input type="text" class="form-control" formControlName="thirdPartyPhone">
        </div>
        <div class="col-md-4 mb-3">
          <label class="form-label fw-semibold">Patente Vehículo Tercero *</label>
          <input type="text" class="form-control" formControlName="thirdPartyPlate">
        </div>
        <div class="col-md-4 mb-3">
          <label class="form-label fw-semibold">Año Vehículo Tercero *</label>
          <input type="number" class="form-control" formControlName="thirdPartyYear">
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 mb-3">
          <label class="form-label fw-semibold">Marca Tercero *</label>
          <app-sheet-select
            [items]="brands() ?? []"
            bindLabel="name"
            bindValue="code"
            title="Marca Tercero"
            placeholder="Seleccione marca..."
            formControlName="thirdPartyBrandCode"
            [clearable]="false"
            [searchable]="(brands()?.length ?? 0) > 5">
          </app-sheet-select>
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label fw-semibold">Modelo Tercero *</label>
          <app-sheet-select
            [items]="filteredModels()"
            bindLabel="name"
            bindValue="code"
            title="Modelo Tercero"
            placeholder="Seleccione modelo..."
            formControlName="thirdPartyModelCode"
            [clearable]="false"
            [searchable]="filteredModels().length > 5">
          </app-sheet-select>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-6 mb-3 d-flex align-items-center">
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="thirdPartyHasInsurance" formControlName="thirdPartyHasInsurance">
            <label class="form-check-label fw-semibold ms-2" for="thirdPartyHasInsurance">¿Tiene seguro contra todo riesgo?</label>
          </div>
        </div>
        <div class="col-md-6 mb-3 d-flex align-items-center">
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="thirdPartyTookResponsibility" formControlName="thirdPartyTookResponsibility">
            <label class="form-check-label fw-semibold ms-2" for="thirdPartyTookResponsibility">¿Asumió responsabilidad en el lugar?</label>
          </div>
        </div>
      </div>
    </div>
  }
}
